import React, { Component } from 'react';

import { Radio, Select, Input, Spin, Modal, Upload, Tooltip, Button, Icon, message, Checkbox, Form, DatePicker} from 'antd';
import services from '../services';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import moment from 'moment';

const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;
const Option = Select.Option;


const APP_TABLE_INDEXES = {
    1: "一级指标",
    2: "二级指标",
    3: "三级指标",
    4: "四级指标",
    5: "五级指标",
    6: "六级指标",
    7: "七级指标",
    8: "八级指标",
    9: "九级指标",
};

class DataTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            scores: {},
            values: {},
            selects: {},
            columns: [],
            exParaMap: {},
            attendStudent: '',
            totalStudent: '',
            lateStudent: '',
            levelStudent: '',
            truantStudent: '',
            attendRate: '',
            comment: '',
            listenComment: '',
            evalTimeStr: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            pingyuon: false,
            weekNumon: false,
            lessonNumon: false,
            weekNameon: false,
            classesNameon: false,
            lessonAddresson:false,
            courseNameon:false,
            uploadon:false,
            loading: true,
            visible: false,
            fileList: [],
            fileLoading: false,
            readonly: props.keywords.readonly,
            belongValues: {},
            belongIsShow: false,
            extendEval: [{ name: '', value: '' }, { name: '', value: '' }, { name: '', value: '' }],
        }

        this.dragData = {};
    }

    componentDidMount() {
        this.getExtendEval();
        this.querySearch(this.props.keywords || {});
        this.props.api(this);
    }

    getExtendEval() {
        services.items.findExtendEvalType()
            .then((res) => {
                let extendEval = res.map((item) => { return { name: item.codeName, value: item.codeValue } })
                this.setState({
                    extendEval,
                })

            });
    }


    querySearch(params = {}) {
        this.setState({
            loading: true
        });

        return this.props.querySearch(params)
            .then(response => {
                this.setState({
                    loading: false
                });

                this.setState(response);

                if (typeof this.props.setDomain === 'function') {
                    this.props.setDomain(response.domain);
                }
            }).catch(error => {
                this.setState({
                    loading: false
                });
            });
    }

    openModal() {
        this.props.onOpenModal();
    }

    getCoice(rowId, columnIndex) {
        return this.state.scores[rowId].choices[columnIndex];
    }

    getParents(id, parents, row) {
        if (parents.hasOwnProperty(id) === true) {
            return row.unshift(id), this.getParents(parents[id], parents, row);
        } else {
            return row.slice(1);
        }
    }

    onChange(columnIndex, rowIndex, rowId) {
        const choices = this.state.scores[rowId].choices[0]
        const showScore = choices ? choices.showScore : 1
        const choice = this.state.scores[rowId].choices[columnIndex];
        const data = this.range(+choice.valueLow, +choice.valueHigh);

        this.setState({
            selects: Object.assign({}, this.state.selects, {
                [rowId]: {
                    value: isNaN(+choice.valueNormal) ? 95 : +choice.valueNormal,
                    data,
                    index: columnIndex,
                    showScore: showScore
                }
            })
        });
    }

    onSelect(value, rowId) {
        var select = Object.assign({}, this.state.selects[rowId], {
            value
        });

        this.setState({
            selects: Object.assign({}, this.state.selects, {
                [rowId]: select
            })
        });
    }

    onInput(value, rowId) {
        const choices = this.state.scores[rowId].choices;
        if (this.props.decimal) {
            if (isNaN(+value) === false) {
                var data = this.queryChoiceRange(choices, +value);
                if (data.length) {
                    var choice = data[0];
                    var select = {
                        data: this.range(+choice.valueLow, +choice.valueHigh),
                        value: value,
                        index: choice.index
                    };

                    this.setState({
                        selects: Object.assign({}, this.state.selects, {
                            [rowId]: select
                        })
                    });
                }
            }
        } else {
            if (isNaN(+value) === false) {
                var data = this.queryChoiceRange(choices, +value);
                if (data.length) {
                    const choice = data[0];
                    var select = {
                        data: this.range(+choice.valueLow, +choice.valueHigh),
                        value: +value,
                        index: choice.index
                    };

                    this.setState({
                        selects: Object.assign({}, this.state.selects, {
                            [rowId]: select
                        })
                    });
                }
            }
        }
    }

    queryChoiceRange(choice, value) {
        return choice.map((d, i) => ({
            valueHigh: +d.valueHigh,
            valueNormal: +d.valueNormal,
            valueLow: +d.valueLow,
            label: d.label,
            index: i
        })).filter(d => {
            var min = +d.valueLow;
            var max = +d.valueHigh;
            return value <= max && value >= min;
        })
    }

    onEnter(index) {
        const table = this.refs.table;
        const inputs = table.querySelectorAll('input[type=text]');

        inputs[index + 1].select();
    }

    range(start, stop) {
        var result = [];
        for (stop; stop >= start; stop--) {
            result.push(stop);
        }

        return result;
    }

    componentWillReceiveProps(nextProps) {
        const itemId = nextProps.keywords.itemId;
        if (itemId && itemId !== this.props.keywords.itemId) {
            this.querySearch({
                itemId
            });
        }

        this.setState({
            readonly: nextProps.keywords.readonly
        });

        if (this.defaultScore !== nextProps.defaultScore) {
            this.defaultScore = nextProps.defaultScore;

            var selects = {};
            for (var rowId in this.state.selects) {
                const choices = this.state.scores[rowId].choices;

                if (isNaN(+this.defaultScore) === false) {
                    var data = this.queryChoiceRange(choices, +this.defaultScore);
                    if (data.length) {
                        const choice = data[0];
                        var select = {
                            data: this.range(+choice.valueLow, +choice.valueHigh),
                            value: +this.defaultScore,
                            index: choice.index,
                            showScore: choices[0].showScore
                        };

                        selects[rowId] = select;
                    }
                }
            }

            this.setState({
                selects
            });
        }
    }

    clearEvalDataSource() {
        this.setState({
            fileList: []
        })
    }

    getEvalDataSource() {
        const {
            data,
            selects,
            scores,
            attendStudent,
            totalStudent,
            lateStudent,
            levelStudent,
            truantStudent,
            comment,
            pingyuon,
            weekNumon,
            lessonNumon,
            weekNameon,
            classesNameon,
            lessonAddresson,
            courseNameon,
            uploadon,
            listenComment,
            evalTimeStr,
            belongValues
        } = this.state;
        const fileList = this.getFileIds(this.state.fileList);
        return {
            fileList: fileList,
            pingyuon: pingyuon,
            weekNumon: weekNumon,
            lessonNumon: lessonNumon,
            weekNameon: weekNameon,
            attendStudent: attendStudent,
            classesNameon: classesNameon,
            lessonAddresson:lessonAddresson,
            courseNameon: courseNameon,
            uploadon:uploadon,
            totalStudent: totalStudent,
            lateStudent: lateStudent,
            levelStudent: levelStudent,
            truantStudent: truantStudent,
            listenComment: listenComment,
            evalTimeStr: evalTimeStr,
            resultComment: comment,
            belongValues,
            evalResult: data.map(d => {
                const id = d.id;
                const {
                    index,
                    value
                } = selects[id];

                const score = scores[id];
                const choice = score.choices[index];
                const questionDetail = score.questionDetail;
                return {
                    questionId: score.id,
                    option: {
                        itemId: score.pid,
                        select: '',
                        selectScore: value,
                        selectLabel: choice.label,
                    },
                    questionDetails: questionDetail
                }
            })
        };
    }

    getFileIds(data) {

        const fileList = [];
        data.forEach(d => {
            if (d.status === 'done' && d.response.code === 200) {
                const fileId = d.response.payload.data[0].id
                const fileName = d.response.payload.data[0].fileName
                fileList.push({ "id": fileId, "fileName": fileName, "type": d.type })
            }
        })
        return fileList;
    }

    setComment(comment) {

        this.setState({
            comment: comment + (this.state.comment ? ("," + this.state.comment) : "")
        });

    }

    onQuestionChange(checkArr, rowIndex, rowId) {
        let questionDetail = []
        const details = this.state.scores[rowId].questionDetail;
        for (let j = 0; j < details.length; j++) {
            if (checkArr instanceof Array) {
                const checkIndex = checkArr.findIndex(a => a === j)
                if (checkIndex !== -1) {
                    questionDetail.push(Object.assign({}, details[checkArr[checkIndex]], { "checked": "true" }));
                } else {
                    questionDetail.push(Object.assign({}, details[j], { "checked": "false" }))
                }
            } else {
                const value = checkArr.target.value
                if (value === j) {
                    questionDetail.push(Object.assign({}, details[value], { "checked": "true" }));
                } else {
                    questionDetail.push(Object.assign({}, details[j], { "checked": "false" }));
                }
            }
        }
        this.setState({
            scores: Object.assign({}, this.state.scores, {
                [rowId]: Object.assign({}, this.state.scores[rowId], {
                    questionDetail: questionDetail
                })
            })
        })

    }

    displayDetailText(detail, rowId, index) {
        return detail.type === 2 && detail.checked === "true" ?
            <span>
                <Input style={{ width: "160px" }}
                    placeholder="请填写"
                    value={detail.text}
                    onChange={e => this.onQuestionTextChange(e, rowId, index)}
                />
            </span>
            : ''
    }

    onQuestionTextChange(e, rowId, index) {
        const details = (this.state.scores[rowId].questionDetail || []).map((detail, i) => {
            if (index === i) {
                detail.text = e.target.value
            }
            return detail
        })
        this.setState({
            scores: Object.assign({}, this.state.scores, {
                [rowId]: Object.assign({}, this.state.scores[rowId], {
                    questionDetail: details
                })
            })
        })
    }

    displayQuestion(state) {
        for (let i = 0; i < state.data.length; i++) {
            const id = state.data[i].id
            const score = state.scores[id]
            if (score.questionDetail) {
                return true
            }
        }
    }

    getQuestionType(state, index) {
        const id = state.data[index].id
        const score = state.scores[id]
        if (score.questionDetail) {
            const types = score.questionDetail.map(m => {
                return m.type
            })
            return types[0]
        }
    }

    setBelong(index, row) {
        const belongList = row.belongList;
        if (belongList.length == 0) {
            return '';
        }
        const belong = belongList.find(e => e.choice === 'choice' + (index + 1));
        const belongValues = this.state.belongValues;
        if (belong) {
            const belongValue = belongValues[row.id];
            let data = '';
            if (belongValue && belongValue.choice === index + 1) {
                data = belongValue.value;
            }
            return (
                <Form.Item
                    label={belong.title}
                >
                    <Input.TextArea
                        value={data}
                        style={{ height: 100 }}
                        onInput={(event) => {
                            const val = event.target.value;
                            belongValues[row.id] = {
                                id: belong.id,
                                choice: index + 1,
                                value: val
                            }
                            this.setState({
                                belongValues
                            })
                        }}
                    />
                </Form.Item>
            )
        }
        delete belongValues[row.id];
        return '';
    }

    render() {
        const props = this.props
        let kaoqingDiv;
        let tingkeDiv;
        let listenTimeDiv;
        let uploadDiv;
        const state = this.state;
        const evalEx = this.state.exParaMap.extParams;
        const commentDesc = this.state.exParaMap.extParams ? this.state.exParaMap.extParams.commentDesc : ''
        const tingkeDesc = this.state.exParaMap.extParams ? this.state.exParaMap.extParams.tingkeDesc : ''
        const questionDesc = this.state.exParaMap.extParams ? this.state.exParaMap.extParams.questionDesc || '存在问题' : ''
        const uploadDesc = this.state.exParaMap.extParams ? this.state.exParaMap.extParams.uploadDesc || '记录课堂的美好瞬间' : ''
        const extendEval = this.state.extendEval || [];
        for (var key in evalEx) {
            if (evalEx[key] != null && evalEx[key] != 'undefined') {
                for (var extendKey in extendEval) {
                    if (extendEval[extendKey] != null && extendEval[extendKey] != 'undefined') {
                        if (evalEx[key].toString().indexOf(extendEval[extendKey].value + "on") !== -1) {
                            if ("kaoqing" === extendEval[extendKey].value) {
                                kaoqingDiv =
                                    <tr>
                                        <td colspan={state.columns.length}>
                                            {extendEval[0].name}
                                        </td>
                                        <td colspan={2}>
                                            应到人数：<input onChange={(event => {
                                                let value = event.target.value
                                                if (value === "") {
                                                    this.setState({
                                                        totalStudent: null,
                                                        attendRate: '0.00%'
                                                    })
                                                    return;
                                                }
                                                if (!/^[+]{0,1}(\d+)$/.test(value)) {
                                                    Modal.error({
                                                        title: '提示',
                                                        content: '请输入正整数'
                                                    })
                                                    this.setState({
                                                        totalStudent: 0,
                                                        attendRate: '0.00%'
                                                    })
                                                } else {
                                                    const attendRate = (this.state.attendStudent / event.target.value * 100).toFixed(2)
                                                    this.setState({
                                                        totalStudent: event.target.value,
                                                        attendRate: attendRate + '%'
                                                    })
                                                }
                                            })}
                                                onClick={(event) => {
                                                    const classesId = this.props.keywords.classesId
                                                    if (classesId && !isNaN(classesId)) {
                                                        services.student.findClassSize(this.props.keywords)
                                                            .then(response => {
                                                                this.setState({
                                                                    totalStudent: response == 0 ? undefined : response
                                                                })
                                                            })
                                                    }
                                                }}
                                                value={this.state.totalStudent}
                                                readOnly={this.state.readonly}
                                            /> &nbsp;
                                            实到人数：<input onChange={(event => {
                                                let value = event.target.value
                                                if (value === "") {
                                                    this.setState({
                                                        attendStudent: null,
                                                        attendRate: '0.00%'
                                                    })
                                                    return;
                                                }
                                                if (!/^[+]{0,1}(\d+)$/.test(value)) {
                                                    Modal.error({
                                                        title: '提示',
                                                        content: '请输入正整数'
                                                    })
                                                    this.setState({
                                                        attendStudent: 0,
                                                        attendRate: '0.00%'
                                                    })
                                                } else {
                                                    const attendRate = (event.target.value / this.state.totalStudent * 100).toFixed(2)
                                                    this.setState({
                                                        attendStudent: event.target.value,
                                                        attendRate: attendRate + '%'
                                                    })
                                                }
                                            })}
                                                value={this.state.attendStudent}
                                                readOnly={this.state.readonly}
                                            /> &nbsp;
                                            请假人数：<input onChange={event => {
                                                let value = event.target.value
                                                if (value === "") {
                                                    this.setState({
                                                        levelStudent: null,
                                                    })
                                                    return;
                                                }
                                                if (!/^[+]{0,1}(\d+)$/.test(value)) {
                                                    Modal.error({
                                                        title: '提示',
                                                        content: '请输入正整数'
                                                    })
                                                    this.setState({
                                                        levelStudent: 0,
                                                    })
                                                } else {
                                                    this.setState({
                                                        levelStudent: event.target.value
                                                    })
                                                }
                                            }}
                                                value={this.state.levelStudent}
                                                readOnly={this.state.readonly}
                                            /> <br /><br />
                                            迟到人数：<input onChange={event => {
                                                let value = event.target.value
                                                if (value === "") {
                                                    this.setState({
                                                        lateStudent: null,
                                                    })
                                                    return;
                                                }
                                                if (!/^[+]{0,1}(\d+)$/.test(value)) {
                                                    Modal.error({
                                                        title: '提示',
                                                        content: '请输入正整数'
                                                    })
                                                    this.setState({
                                                        lateStudent: 0,
                                                    })
                                                } else {
                                                    this.setState({
                                                        lateStudent: event.target.value
                                                    })
                                                }
                                            }}
                                                value={this.state.lateStudent}
                                                readOnly={this.state.readonly}
                                            />  &nbsp;
                                            旷课人数：<input onChange={event => {
                                                let value = event.target.value
                                                if (value === "") {
                                                    this.setState({
                                                        truantStudent: null,
                                                    })
                                                    return;
                                                }
                                                if (!/^[+]{0,1}(\d+)$/.test(value)) {
                                                    Modal.error({
                                                        title: '提示',
                                                        content: '请输入正整数'
                                                    })
                                                    this.setState({
                                                        truantStudent: 0,
                                                    })
                                                } else {
                                                    this.setState({
                                                        truantStudent: event.target.value
                                                    })
                                                }
                                            }}
                                                value={this.state.truantStudent}
                                                readOnly={this.state.readonly}
                                            />  &nbsp;&nbsp;&nbsp;&nbsp;
                                            到课率：<input onChange={event => {
                                                const attendRate = (this.state.attendStudent / this.state.totalStudent * 100).toFixed(2)
                                                this.setState({
                                                    attendRate: attendRate + '%'
                                                })
            
                                            }}
                                                value={this.state.attendRate}
                                                readOnly={this.state.readonly}
                                            />
                                        </td>
                                    </tr>
                            }
                            if ("tingke" === extendEval[extendKey].value) {
                                tingkeDiv =
                                    <tr>
                                        <td colspan={state.columns.length}>
                                            {extendEval[1].name}
                                        </td>
                                        <td colspan={2}>
                                            <TextArea maxlength={1000} disabled={this.state.readonly} rows={4}
                                                placeholder={tingkeDesc && tingkeDesc.length > 0 ? tingkeDesc : "教学设备、门窗桌椅、环境卫生、噪声干扰等方面发现的问题和建议："}
                                                onChange={(event) => {
                                                    if (this.state.listenComment.length <= 1000) {
                                                        this.setState({
                                                            listenComment: event.target.value
                                                        });
                                                    }
            
                                                }} value={this.state.listenComment}></TextArea>
                                            你还可以输入<span className="text-number">{1000 - this.state.listenComment.length}</span>个字。
                                        </td>
                                    </tr>
                            }
                            if ("listenTime" === extendEval[extendKey].value) {
                                listenTimeDiv =
                                    <tr>
                                        <td colspan={state.columns.length}>
                                            {extendEval[3].name}
                                        </td>
                                        <td colspan={2}>
                                            <DatePicker 
                                                placeholder={"请选择时间"} 
                                                value={this.state.evalTimeStr ? moment(this.state.evalTimeStr) : undefined}
                                                style={{ width: 240}}
                                                allowClear={false}
                                                showTime={false}
                                                format={'YYYY-MM-DD'} 
                                                onChange={ (event) => {
                                                    this.setState({
                                                        evalTimeStr: moment(event).format("YYYY-MM-DD")
                                                    });
                                                } }
                                            />
                                        </td>
                                    </tr>
                            }
                            if ("upload" === extendEval[extendKey].value) {
                                uploadDiv =
                                    <tr>
                                        <td colspan={state.columns.length}>
                                            {extendEval[extendKey].name || "上传附件"}
                                        </td>
                                        <td colspan={2}>
                                            <Upload
                                                action={services.score.upload}
                                                style={{ width: 240 }}
                                                // accept= '.docx,.doc,.jpeg,.jpg,.png,.pdf,.mp4,image/jpeg,image/jpg,image/png,application/pdf,'
                                                showDownloadIcon={true}
                                                className='upload-list-inline'
                                                listType='picture'
                                                onRemove={async (file) => {
                                                    this.setState({
                                                        fileLoading: true
                                                    })
                                                    const fileList = this.state.fileList;
                                                    const f = fileList.find(f => f.uid === file.uid);
                                                    if (f.response && f.response.code === 200) {
                                                        const dataList = f.response.payload.data;
                                                        const res = await services.score.deleteFile(dataList);
                                                        if (res.code === 200) {
                                                            message.success("文件删除成功");
                                                            return true;
                                                        } else if (res.code === 404) {
                                                            return true;
                                                        }
                                                        return false;
                                                    }
                                                    this.setState({
                                                        fileLoading: false
                                                    })
                                                }}
                                                fileList={this.state.fileList}
                                                withCredentials={true}
                                                disabled={this.state.readonly}
                                                onChange={({ file, fileList }) => {
                                                    if (file.status === 'uploading') {
                                                        this.setState({
                                                            fileLoading: true
                                                        })
                                                    }
                                                    const newfileList = this.state.fileList;
                                                    if (file.status === 'done') {
                                                        const res = file.response;
                                                        if (res.code !== 200) {
                                                            // 如果不等于 200 ，说明上传失败，手动改变文件状态
                                                            const f = fileList.find(f => f.uid === file.uid);
                                                            f.status = 'error';
                                                            message.error(`文件上传失败：${res.message}`);
                                                        } else {
                                                            // fileList = fileList.map(f => Object.assign({},f,{
                                                            //     url: f.type.indexOf("image") != -1 ?`${services.score.download}?id=${f.response.payload.data[0].id}`:f.url,
                                                            //     thumbUrl: f.type.search("image") != -1 ?`${services.score.download}?id=${f.response.payload.data[0].id}`:f.thumbUrl,
                                                            // }))
                                                            fileList = fileList.map(f => Object.assign({}, f, {
                                                                url: f.response.payload.data ? `${services.score.download}?id=${f.response.payload.data[0].id}` : '',
                                                                thumbUrl: f.response.payload.data ? `${services.score.thumbnails}?id=${f.response.payload.data[0].id}` : '',
                                                            }))
                                                            message.success("文件上传成功");
                                                        }
                                                        this.setState({
                                                            fileLoading: false
                                                        })
                                                    }
                                                    if (file.status === 'error') {
                                                        this.setState({
                                                            fileLoading: false
                                                        })
                                                        message.error("文件上传失败");
                                                    }
                                                    // 过滤掉无法上传的
                                                    this.state.fileList = fileList.filter(f => f.status);
                                                    // 每次都要 set 一下，主要是 set fileList，不然 onChange 只触发一次
                                                    this.setState({
                                                        newfileList
                                                    })
                                                }}
                                                beforeUpload={(file) => {
                                                    // 上传前的校验
                                                    return new Promise((resolve, reject) => {
                                                        services.score.checkUpload({ isListen: this.props.keywords.isListen }).then(response => {
                                                            if (response.code === 200) {
                                                                const flg = this.state.fileList.some(f => file.name === f.name);
                                                                if (flg) {
                                                                    message.warn('无法上传相同的文件');
                                                                    return reject(false);
                                                                } else {
                                                                    return resolve(true);
                                                                }
                                                            } else {
                                                                return reject(false);
                                                            }
                                                        });
                                                    })
                                                }}
                                            >
                                                <Tooltip placement="right" title={`${uploadDesc}`}>
                                                    <Button
                                                        disabled={this.state.readonly}
                                                        type="primary"
                                                    >
                                                        <Icon type="upload" />
                                                        {extendEval[extendKey].name || "上传附件"}
                                                    </Button>
                                                </Tooltip>
                                            </Upload>
                                        </td>
                                    </tr>
                            }
                        }
                    }
                }
                if (evalEx[key].toString().indexOf("pingyuon") !== -1) {
                    this.state.pingyuon = true;
                }
                if (evalEx[key].toString().indexOf("classesNameon") !== -1) {
                    this.state.classesNameon = true;
                }
                if (evalEx[key].toString().indexOf("lessonAddresson") !== -1) {
                    this.state.lessonAddresson = true;
                }
                if (evalEx[key].toString().indexOf("courseNameon") !== -1) {
                    this.state.courseNameon = true;
                }
                if (evalEx[key].toString().indexOf("uploadfileon") !== -1) {
                    this.state.uploadon = true;
                }
                if (evalEx[key].toString().indexOf("weekNumon") !== -1) {
                    this.state.weekNumon = true;
                }
                if (evalEx[key].toString().indexOf("lessonNumon") !== -1) {
                    this.state.lessonNumon = true;
                }
                if (evalEx[key].toString().indexOf("weekNameon") !== -1) {
                    this.state.weekNameon = true;
                }
            }
        }

        return (
            <div className="root-main">
                <div className="data-table">
                    <div className="data-table-container">
                        <div className="data-table-header">
                            <table border="0" className="data-table-header">
                                <tr>
                                    {
                                        state.columns.map(column => (
                                            <th className="score-th" style={{ width: 120 }}>{APP_TABLE_INDEXES[column]}</th>
                                        ))
                                    }
                                    <th>评价依据</th>
                                    {

                                        this.displayQuestion(state) ? <th style={{ width: 310 }}>
                                            {questionDesc}</th> : ''

                                    }
                                    <th style={{ width: 410 }}>评价结果</th>
                                    {
                                        state.belongIsShow ?
                                            <th style={{ width: 200 }}>附属题目</th>
                                            :
                                            ''
                                    }
                                </tr>
                            </table>
                        </div>
                        <Spin tip="数据加载中..." spinning={this.state.loading}>
                            <div className="data-table-body">
                                <div className="data-table-viewport">
                                    <div className="data-table-content">
                                        <div className="data-table-main">
                                            <table border="0" ref="table">
                                                {
                                                    state.data.map((row, rowIndex) => (
                                                        <tr>
                                                            {
                                                                row.columns.map(column => (
                                                                    <td
                                                                        rowspan={column.rowspan}
                                                                        colspan={column.colspan}
                                                                        className="score-td"
                                                                        style={{ width: 120 }}
                                                                    >
                                                                        {state.values[column.value]}
                                                                    </td>
                                                                ))
                                                            }
                                                            <td>{state.scores[row.id].label}</td>
                                                            {
                                                                this.displayQuestion(state) ?
                                                                    <td style={{ width: 310 }}>
                                                                        <span>
                                                                            {
                                                                                this.getQuestionType(state, rowIndex) === 3 ?
                                                                                    <RadioGroup
                                                                                        onChange={(value) => {
                                                                                            this.onQuestionChange(value, rowIndex, row.id);
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            (state.scores[row.id].questionDetail || []).map((detail, i) => (
                                                                                                <span>
                                                                                                    <Radio disabled={this.state.readonly} checked={detail.checked} value={i}>{detail.name}</Radio>
                                                                                                </span>
                                                                                            ))
                                                                                        }
                                                                                    </RadioGroup>
                                                                                    :
                                                                                    <CheckboxGroup
                                                                                        onChange={(value) => {
                                                                                            this.onQuestionChange(value, rowIndex, row.id);
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            (state.scores[row.id].questionDetail || []).map((detail, i) => (
                                                                                                <span>
                                                                                                    <Checkbox disabled={this.state.readonly} checked={detail.checked} value={i}>{detail.name}</Checkbox>
                                                                                                    {
                                                                                                        this.displayDetailText(detail, row.id, i)
                                                                                                    }
                                                                                                </span>
                                                                                            ))
                                                                                        }
                                                                                    </CheckboxGroup>
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    :
                                                                    ''
                                                            }
                                                            <td style={{ width: 410 }}>
                                                                <RadioGroup
                                                                    onChange={(event) => {
                                                                        this.onChange(+event.target.value, rowIndex, row.id);
                                                                    }}
                                                                    value={(props.relateScores || {})[row.id + '-index'] || state.selects[row.id].index}>
                                                                    {
                                                                        state.scores[row.id].choices.map((choice, i) => (
                                                                            <Radio disabled={(props.relateScores || {})[row.id + '-index'] || this.state.readonly} value={i}>{choice.label}</Radio>
                                                                        ))
                                                                    }
                                                                </RadioGroup>
                                                                {
                                                                    state.selects[row.id].showScore != 2 ?
                                                                        <div className="scores-item">
                                                                            得分:
                                                                            <span>
                                                                                {
                                                                                    this.props.decimal ? '' : (
                                                                                        <Select
                                                                                            value={(props.relateScores || {})[row.id] >= 0 ? (props.relateScores || {})[row.id] : state.selects[row.id].value}
                                                                                            style={{ width: 80 }}
                                                                                            disabled={this.state.readonly || (props.relateScores || {})[row.id] >= 0}
                                                                                            onChange={(value) => {
                                                                                                this.onSelect(value, row.id);
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                state.selects[row.id].data.map(value => (
                                                                                                    <Option value={value}>{value}</Option>
                                                                                                ))
                                                                                            }
                                                                                        </Select>
                                                                                    )
                                                                                }
                                                                            </span>
                                                                            {
                                                                                this.props.decimal ? (
                                                                                    <Input
                                                                                        style={{ width: 60, marginLeft: 10 }}
                                                                                        disabled={this.state.readonly}
                                                                                        value={state.selects[row.id].value}
                                                                                        onInput={(event) => {
                                                                                            this.onInput(event.target.value, row.id);
                                                                                        }}

                                                                                        maxLength={5}

                                                                                        onKeyUp={(event) => {
                                                                                            if (event.keyCode === 13) {
                                                                                                this.onEnter(rowIndex);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                ) : (
                                                                                    <Input
                                                                                        style={{ width: 50 }}
                                                                                        disabled={this.state.readonly || (props.relateScores || {})[row.id] >= 0}
                                                                                        value={(props.relateScores || {})[row.id] >= 0 ? props.relateScores[row.id] : state.selects[row.id].value}
                                                                                        onInput={(event) => {
                                                                                            this.onInput(event.target.value, row.id);
                                                                                        }}

                                                                                        onKeyUp={(event) => {
                                                                                            if (event.keyCode === 13) {
                                                                                                this.onEnter(rowIndex);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                )
                                                                            }
                                                                            {
                                                                                (props.relateScores || {})[row.id] >= 0 ?
                                                                                    <span style={{ color: 'red' }}>*此处自动从三方汇总获取分数</span>
                                                                                    : ''
                                                                            }
                                                                            {/* <Input
                                                                    style={{ width: 50 }}
                                                                    disabled={this.state.readonly}
                                                                    value={state.selects[row.id].value}
                                                                    onInput={(event) => {
                                                                        this.onInput(event.target.value, row.id);
                                                                    }}

                                                                    onKeyUp={(event) => {
                                                                        if (event.keyCode === 13) {
                                                                            this.onEnter(rowIndex);
                                                                        }
                                                                    }}
                                                                /> */}
                                                                        </div>
                                                                        : ''
                                                                }
                                                            </td>
                                                            {
                                                                state.belongIsShow ?
                                                                    <td style={{ width: 200 }}>
                                                                        {
                                                                            this.setBelong(state.selects[row.id].index, state.scores[row.id])
                                                                        }
                                                                    </td> :
                                                                    ''
                                                            }
                                                        </tr>
                                                    ))
                                                }
                                                {kaoqingDiv}
                                                {listenTimeDiv}
                                                {tingkeDiv}
                                                <tr>
                                                    <td colspan={state.columns.length}>
                                                        {/* 本次课综合评语(特点、不足及建议) */}
                                                        {commentDesc || "本次课综合评语(特点、不足及建议)"}
                                                        {/* {commentDesc || "问题及建议" } */}
                                                    </td>
                                                    <td colspan={2}>
                                                        <TextArea maxlength={1000} disabled={this.state.readonly} rows={4} onChange={(event) => {
                                                            if (this.state.comment.length <= 1000) {
                                                                this.setState({
                                                                    comment: event.target.value
                                                                });
                                                            }

                                                        }} value={this.state.comment}></TextArea>
                                                        <span className="select-comments" onClick={this.openModal.bind(this)}>选择评语</span> 你还可以输入<span className="text-number">{1000 - this.state.comment.length}</span>个字。
                                                    </td>
                                                </tr>
                                                {uploadDiv}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>

                    </div>
                </div >
            </div >
        );
    }
}

export default DataTable;